import { FC, SVGProps } from 'react'

export const Trophy: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 4.20386V7.64761C4 10.1289 5.9875 12.1851 8.46875 12.2039C9.06232 12.208 9.65085 12.0946 10.2004 11.8703C10.75 11.646 11.2498 11.3152 11.671 10.8969C12.0921 10.4787 12.4264 9.98119 12.6545 9.43318C12.8826 8.88517 13 8.29744 13 7.70386V4.20386C13 4.07125 12.9473 3.94407 12.8536 3.8503C12.7598 3.75654 12.6326 3.70386 12.5 3.70386H4.5C4.36739 3.70386 4.24021 3.75654 4.14645 3.8503C4.05268 3.94407 4 4.07125 4 4.20386Z"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.5 14.7039H10.5"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.5 12.2039V14.7039"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.8877 8.70386H13.5002C14.0306 8.70386 14.5393 8.49314 14.9144 8.11807C15.2895 7.743 15.5002 7.23429 15.5002 6.70386V5.70386C15.5002 5.57125 15.4475 5.44407 15.3537 5.3503C15.26 5.25654 15.1328 5.20386 15.0002 5.20386H13.0002"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.1249 8.70386H3.49365C2.96322 8.70386 2.45451 8.49314 2.07944 8.11807C1.70437 7.743 1.49365 7.23429 1.49365 6.70386V5.70386C1.49365 5.57125 1.54633 5.44407 1.6401 5.3503C1.73387 5.25654 1.86104 5.20386 1.99365 5.20386H3.99365"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
